// extracted by mini-css-extract-plugin
export var cartEmpty = "shop-order-summary-module--cart-empty--378df";
export var checkbox = "shop-order-summary-module--checkbox--5044e";
export var consentForm = "shop-order-summary-module--consent-form--74d7b";
export var consentFormDisclaimer = "shop-order-summary-module--consent-form-disclaimer--43feb";
export var content = "shop-order-summary-module--content--be1d1";
export var description = "shop-order-summary-module--description--63783";
export var main = "shop-order-summary-module--main--0d76a";
export var orderBox = "shop-order-summary-module--order-box--ba921";
export var paymentBox = "shop-order-summary-module--payment-box--8e53d";
export var paymentPreview = "shop-order-summary-module--payment-preview--9ea15";
export var paymentSpace = "shop-order-summary-module--payment-space--869e8";
export var paymentTitle = "shop-order-summary-module--payment-title--8c28e";
export var registerForm = "shop-order-summary-module--register-form--c1fd4";
export var registerFormBox = "shop-order-summary-module--register-form-box--5dcd2";
export var span = "shop-order-summary-module--span--a3726";
export var submitButton = "shop-order-summary-module--submit-button--d6438";
export var summary = "shop-order-summary-module--summary--c44bd";
export var summaryBox = "shop-order-summary-module--summary-box--d7e62";
export var title = "shop-order-summary-module--title--0c2db";